import { Badge } from "@arcadeai/design-system/components/ui/atoms/badge";
import { DropdownMenuItem } from "@arcadeai/design-system/components/ui/atoms/dropdown-menu";
import { Link } from "@tanstack/react-router";
import { MailIcon } from "lucide-react";

export type InvitationsMenuItemProps = { count: number };

export function InvitationsMenuItem({ count }: InvitationsMenuItemProps) {
  return (
    <DropdownMenuItem
      className="cursor-pointer"
      render={
        <Link
          from="/orgs/$organizationId/projects/$projectId/invitations/"
          to="."
        />
      }
    >
      <MailIcon className="size-4" />
      My invitations
      {count > 0 && (
        <Badge className="ml-auto" variant="warning">
          {count}
        </Badge>
      )}
    </DropdownMenuItem>
  );
}
